import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BookingForm from "../components/BookingForm";
const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [
    "images/slider-3.jpg",
    "images/slider-2.jpg",
    "images/slider-1.jpg",
  ];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
    }, 30000000); // Change slide every 3 seconds

    return () => clearInterval(slideInterval);
  }, []);

  return (
    <>
      <div
        className="hero-section"
        style={{ position: "relative", minHeight: "500px", height: "auto" }}
      >
        <div className="hero-slider">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`hero-single ${
                index === currentSlide ? "active" : ""
              }`}
              style={{
                backgroundImage: `url(${slide})`,
                opacity: index === currentSlide ? 1 : 0,
                transition: "opacity 1s ease-in-out",
                position: index === currentSlide ? "relative" : "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: index === currentSlide ? "auto" : "100%",
                minHeight: "500px",
                // paddingTop: index === currentSlide ? "80px" : "180px",
                paddingBottom: index === currentSlide ? "120px" : "0",
                backgroundSize: "cover",
                backgroundPosition: "center",
                zIndex: index === currentSlide ? 1 : 0,
                // display & alignItems moved to CSS (index.css) for responsive control
              }}
            >
              <div className="container">
                <div className="row align-items-center w-100">
                  <div className="col-md-12 col-lg-12 mx-auto">
                    <div
                      className="hero-content text-center"
                      style={{ height: "auto" }}
                    >
                      <h6
                        className="hero-sub-title"
                        style={{
                          opacity: index === currentSlide ? 1 : 0,
                          transition: "opacity 1s ease-in-out 0.5s",
                          transform:
                            index === currentSlide
                              ? "translateY(0)"
                              : "translateY(20px)",
                        }}
                      >
                        {/* Welcome To{" "} */}
                        {/* <span className="milesgoride">Milesgoride</span> */}
                      </h6>
                      <p
                        className=""
                        style={{
                          opacity: index === currentSlide ? 1 : 0,
                          transition: "opacity 1s ease-in-out 0.8s",
                          transform:
                            index === currentSlide
                              ? "translateY(0)"
                              : "translateY(20px)",
                        }}
                      ></p>
                      <BookingForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* about us*/}
      <div className="about-area mr">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-left wow fadeInLeft" data-wow-delay=".25s">
                <div className="about-img">
                  <img
                    src="images/hatchback.png"
                    alt="MilesGoRide Branded Car"
                  />
                </div>
                {/* <div className="about-experience"> */}
                {/* <div className="about-experience-icon">
                    <img src="images/taxi-booking.svg" alt="" />
                  </div> */}
                {/* <b>
                    30 Years Of <br /> Quality Service
                  </b> */}
                {/* <b> Quality Service</b> */}
                {/* </div> */}
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-right wow fadeInRight"
                data-wow-delay=".25s"
              >
                <div className="site-heading mb-3">
                  <span className="site-title-tagline justify-content-start">
                    <i className="flaticon-drive" /> About Us
                  </span>
                  <h2 className="site-title">
                    Welcome to <span>MilesGoRide</span>
                  </h2>
                </div>
                <p className="about-text">
                  Your trusted travel companion for every outstation journey!
                  🚖✨
                </p>
                <div className="about-list-wrapper">
                  <ul className="about-list list-unstyled">
                    {/* <li>At vero eos et accusamus et iusto odio.</li> */}
                    <li>
                      Built to deliver safe, comfortable, and worry-free rides
                    </li>
                    <li>
                      Committed to providing safe, comfortable and worry-free
                      travel, ensuring a smooth ride from booking to drop-off
                    </li>
                  </ul>
                </div>
                <Link to="/about" className="theme-btn mt-4">
                  Discover More
                  <i className="fas fa-arrow-right" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* about us end*/}
      {/* why choose us */}

      <div className="video-area vda-2">
        <div className="container">
          <div
            className="video-content"
            style={{ backgroundImage: "url(images/cardsaS.png)" }}
          >
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="video-wrapper">
                  {/* <a
                    className="play-btn popup-youtube"
                    href="https://www.youtube.com/watch?v=ckHzmP1evNU"
                  >
                    <i className="fas fa-play" /> */}
                  {/* </a> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="choose-area py-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="choose-content">
                <div
                  className="site-heading wow fadeInDown mb-4"
                  data-wow-delay=".25s"
                >
                  <span className="site-title-tagline text-white justify-content-start">
                    <i className="flaticon-drive" /> Why Choose Us
                  </span>
                  <h2 className="site-title text-white mb-10 travel-title">
                    We are dedicated <span>to provide</span> quality Outstation
                    Travel
                  </h2>
                  <p className="text-white">
                    At MILES GO RIDE, we specialize in reliable and comfortable
                    outstation cab services designed to make long-distance
                    journeys smooth and stress-free. Whether it’s a business
                    trip, family visit, or leisure travel, we ensure every mile
                    is safe, punctual, and enjoyable.
                  </p>
                </div>
                <div className="choose-img wow fadeInUp" data-wow-delay=".25s">
                  <img src="images/testing.png" alt="" />
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="choose-content-wrapper wow fadeInRight"
                data-wow-delay=".25s"
              >
                <div className="choose-item">
                  <span className="choose-count">01</span>
                  <div className="choose-item-icon">
                    <img src="images/taxi-1.svg" alt="" />
                  </div>
                  <div className="choose-item-info">
                    <h3>Travel in Comfort & Style</h3>
                    <p>
                      {/* There are many variations of passages available but the
                      majority have suffered alteration in form injected humour
                      words which don't look even slightly believable. If you
                      are going passage you need there anything embar. */}
                      Experience premium outstation travel with our fleet of
                      clean, spacious and air-conditioned taxis. Each vehicle
                      undergoes rigorous quality checks before every trip,
                      providing a comfortable, safe and worry-free journey.
                    </p>
                  </div>
                </div>
                <div className="choose-item ms-lg-5">
                  <span className="choose-count">02</span>
                  <div className="choose-item-icon">
                    <img src="images/driver.svg" alt="" />
                  </div>
                  <div className="choose-item-info">
                    <h3>Experienced & Trusted MGR Captains </h3>
                    <p>
                      {/* There are many variations of passages available but the
                      majority have suffered alteration in form injected humour
                      words which even slightly believable. If you are going
                      passage you need there anything. */}
                      Travel with confidence knowing that our MGR Captains are
                      skilled, verified and well-versed in long-distance routes.
                      They prioritize your safety, maintain professional driving
                      standards and ensure timely pickups and drop-offs.
                    </p>
                  </div>
                </div>
                <div className="choose-item mb-lg-0">
                  <span className="choose-count">03</span>
                  <div className="choose-item-icon">
                    <img src="images/taxi-location.svg" alt="" />
                  </div>
                  <div className="choose-item-info">
                    <h3>Wide Outstation Coverage</h3>
                    <p>
                      {/* There are many variations of passages available but the
                      majority have suffered alteration in form injected humour
                      words which don't look even slightly believable. If you
                      are going passage you need there anything embar. */}
                      MILES GO RIDE offers reliable outstation cab services
                      across Gujarat, connecting major cities and popular
                      destinations. Choose from one-way or round-trip travel
                      options and enjoy comfortable rides, transparent pricing
                      and dependable service. Pan-India expansion is coming
                      soon.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* why choose us end */}

      <>
        <div className="counter-area py-120">
          <div className="container">
            <div className="counter-wrapper">
              <div className="row">
                <div className="col-lg-3 col-sm-6">
                  <div className="counter-box">
                    <div className="icon">
                      <img src="images/taxi-1.svg" alt="" />
                    </div>
                    <div>
                      <span
                        className="counter"
                        data-count="+"
                        data-to={500}
                        data-speed={3000}
                      >
                        170
                      </span>
                      <h6 className="title">+ Cities </h6>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="counter-box">
                    <div className="icon">
                      <img src="images/happy.svg" alt="" />
                    </div>
                    <div>
                      <span
                        className="counter"
                        data-count="+"
                        data-to={900}
                        data-speed={3000}
                      >
                        189
                      </span>
                      <h6 className="title">+ Happy Clients</h6>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="counter-box">
                    <div className="icon">
                      <img src="images/driver.svg" alt="" />
                    </div>
                    <div>
                      <span
                        className="counter"
                        data-count="+"
                        data-to={700}
                        data-speed={3000}
                      >
                        258
                      </span>
                      <h6 className="title">+ MGR Captains</h6>
                    </div>
                  </div>
                </div>
                <div className="col-lg-3 col-sm-6">
                  <div className="counter-box">
                    <div className="icon">
                      <img src="images/trip.svg" alt="" />
                    </div>
                    <div>
                      <span
                        className="counter"
                        data-count="+"
                        data-to={1800}
                        data-speed={3000}
                      >
                        368
                      </span>
                      <h6 className="title">+ Road Trip Done</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* counter area end */}
        {/* feature area */}
        <div className="feature-area feature-bg py-120">
          <div className="container ">
            <div className="row">
              <div className="col-lg-6 mx-auto">
                <div className="site-heading text-center">
                  <span className="site-title-tagline">Feature</span>
                  <h2 className="site-title text-white">
                    Our Premium Features
                  </h2>
                  <div className="heading-divider" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-3">
                <div
                  className="feature-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="feature-icon">
                    <img src="images/taxi-safety.svg" alt="" />
                  </div>
                  <div className="feature-content">
                    <h4>Safety Assured</h4>
                    <p>
                      {/* There are many variations of majority have suffered
                      alteration in some form injected humour randomised words. */}
                      Your safety is our highest priority. Every MILES GO RIDE
                      vehicle is thoroughly inspected and driven by trained,
                      background-verified chauffeurs, ensuring a secure and
                      worry-free journey from start to finish
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="feature-item mt-lg-5 wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="feature-icon">
                    <img src="images/pickup.svg" alt="" />
                  </div>
                  <div className="feature-content">
                    <h4>On-Time Pickup</h4>
                    <p>
                      We value your time. Our MGR Captains reach your pickup
                      location promptly, helping you begin your outstation
                      journey without delays—whether it’s a short intercity trip
                      or a long-distance ride
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="feature-item wow fadeInUp"
                  data-wow-delay=".25s"
                >
                  <div className="feature-icon">
                    <img src="images/money.svg" alt="" />
                  </div>
                  <div className="feature-content">
                    <h4>Transparent & Competitive Pricing</h4>
                    <p>
                      Enjoy premium service at honest prices. We offer clear,
                      upfront fares with no hidden charges, delivering the best
                      value for both one-way and round-trip outstation travel.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-3">
                <div
                  className="feature-item mt-lg-5 wow fadeInDown"
                  data-wow-delay=".25s"
                >
                  <div className="feature-icon">
                    <img src="images/support.svg" alt="" />
                  </div>
                  <div className="feature-content">
                    <h4>24/7 Support</h4>
                    <p>
                      Our customer support team is available around the clock to
                      assist with bookings, trip updates, or emergency
                      help—because reliable service shouldn’t have time limits
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>

      {/* APP DOWNLOAD SECTION */}
      <div
        className="download-app-area py-5"
        style={{
          background: "linear-gradient(135deg, #0B241E 0%, #153e34 100%)",
          color: "#fff",
        }}
      >
        <div className="container py-4">
          <div className="row align-items-center">
            <div className="col-lg-5 mb-4 mb-lg-0">
              <div className="site-heading mb-0 text-start">
                <span className="site-title-tagline text-success justify-content-start">
                  <i className="fab fa-android me-2" /> Official Mobile Apps
                </span>
                <h2 className="site-title text-white mt-2">
                  Download <span style={{ color: "#49ba09" }}>MilesGoRide</span>{" "}
                  APKs
                </h2>
                <p
                  className="text-white-50 mt-3"
                  style={{ fontSize: "14px", lineHeight: "1.6" }}
                >
                  Download and install our official Android apps directly onto
                  your smartphone. Select User APK to book rides or Captain APK
                  for drivers.
                </p>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="row g-3">
                {/* USER APK CARD */}
                <div className="col-sm-6">
                  <div
                    style={{
                      background: "rgba(255, 255, 255, 0.08)",
                      borderRadius: "16px",
                      padding: "24px",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                    }}
                  >
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "12px",
                          background: "#49ba09",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <i className="fas fa-user-alt text-white fs-4" />
                      </div>
                      <div>
                        <h5
                          className="text-white mb-0"
                          style={{ fontWeight: "700" }}
                        >
                          User App
                        </h5>
                        <small className="text-success fw-bold">
                          Android APK
                        </small>
                      </div>
                    </div>
                    <p
                      className="text-white-50 mb-3"
                      style={{ fontSize: "13px" }}
                    >
                      Book outstation cabs, track driver live location, and view
                      booking history.
                    </p>
                    <a
                      href="/apks/MilesGoRide-User.apk?v=1789218642367"
                      download
                      className="theme-btn w-100 text-center d-block"
                      style={{
                        background: "#49ba09",
                        border: "none",
                        borderRadius: "10px",
                        textDecoration: "none",
                        padding: "12px 16px",
                        fontWeight: "bold",
                      }}
                    >
                      <i className="fab fa-android me-2" /> Download User APK
                    </a>
                  </div>
                </div>

                {/* CAPTAIN APK CARD */}
                <div className="col-sm-6">
                  <div
                    style={{
                      background: "rgba(255, 255, 255, 0.08)",
                      borderRadius: "16px",
                      padding: "24px",
                      backdropFilter: "blur(10px)",
                      border: "1px solid rgba(255,255,255,0.15)",
                    }}
                  >
                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div
                        style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "12px",
                          background: "#49ba09",
                          border: "1px solid #49ba09",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                        }}
                      >
                        <i className="fas fa-taxi text-success fs-4" />
                      </div>
                      <div>
                        <h5
                          className="text-white mb-0"
                          style={{ fontWeight: "700" }}
                        >
                          Driver App
                        </h5>
                        <small className="text-success fw-bold">
                          Captain APK
                        </small>
                      </div>
                    </div>
                    <p
                      className="text-white-50 mb-3"
                      style={{ fontSize: "13px" }}
                    >
                      Accept rides, manage active bookings, navigate routes, and
                      track daily earnings.
                    </p>
                    <a
                      href="/apks/MilesGoRide-Captain.apk?v=1789218642367"
                      download
                      className="theme-btn w-100 text-center d-block"
                      style={{
                        background: "#49ba09",
                        // color: "#0B241E",
                        border: "none",
                        borderRadius: "10px",
                        textDecoration: "none",
                        padding: "12px 16px",
                        fontWeight: "bold",
                      }}
                    >
                      <i className="fab fa-android text-success me-2" />{" "}
                      Download Driver APK
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
